import React, { useEffect, useRef, createElement } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
export const Booking = () => {
  const {
    t
  } = useLanguage();
  const sectionRef = useRef<HTMLElement | null>(null);
  const initialized = useRef(false);
  useEffect(() => {
    const loadCal = () => {
      if (initialized.current) return;
      initialized.current = true;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        (function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if(typeof namespace === "string"){cal.ns[namespace] = cal.ns[namespace] || api;p(cal.ns[namespace], ar);p(cal, ["initNamespace", namespace]);} else p(cal, ar); return;} p(cal, ar); }; })(window, "https://app.cal.com/embed/embed.js", "init");
        Cal("init", "30min", {origin:"https://app.cal.com"});
        Cal.config = Cal.config || {};
        Cal.config.forwardQueryParams = true;
        Cal.ns["30min"]("inline", {
          elementOrSelector:"#my-cal-inline-30min",
          config: {"layout":"month_view","useSlotsViewOnSmallScreen":"true"},
          calLink: "moraima-rebori-lara-bcjdbf/30min",
        });
        Cal.ns["30min"]("ui", {"cssVarsPerTheme":{"light":{"cal-brand":"#4F46E5"},"dark":{"cal-brand":"#818CF8"}},"hideEventTypeDetails":false,"layout":"month_view"});
      `;
      document.body.appendChild(script);
    };
    // Wait until the page is FULLY loaded (browser loading bar gone) before
    // pulling in the heavy Cal.com embed. Then load it immediately in the
    // background so it's ready well before the visitor scrolls to it.
    const schedule = () => {
      const idle = (window as any).requestIdleCallback;
      if (idle) {
        idle(loadCal, {
          timeout: 2000
        });
      } else {
        setTimeout(loadCal, 200);
      }
    };
    if (document.readyState === 'complete') {
      schedule();
      return;
    }
    window.addEventListener('load', schedule, {
      once: true
    });
    return () => window.removeEventListener('load', schedule);
  }, []);
  return <section id="booking" ref={sectionRef} className="py-24 bg-slate-900 text-white" data-id="element-13">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-16">
            {t.booking.title}
          </h2>
          <p className="text-xl text-slate-400" data-id="element-17">{t.booking.subtitle}</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-18">
            <div className="inline-flex items-baseline gap-2 rounded-full bg-indigo-500/15 border border-indigo-500/30 px-6 py-3" data-id="element-19">
              <span className="text-2xl font-bold text-white" data-id="element-20">
                {t.booking.price}
              </span>
            </div>
            <div className="inline-flex items-center gap-2 rounded-full bg-emerald-500/15 border border-emerald-500/30 px-6 py-3" data-id="element-21">
              <CheckCircle2 size={20} className="text-emerald-400" data-id="element-22" />
              <span className="text-lg font-semibold text-emerald-300" data-id="element-23">
                {t.booking.freeFirst}
              </span>
            </div>
          </div>
        </div>

        <div className="min-h-[700px] relative" data-id="element-24">
          {/* Cal.com inline embed container */}
          <div id="my-cal-inline-30min" style={{
          width: '100%',
          height: '100%',
          minHeight: '700px',
          overflow: 'auto'
        }} data-id="element-25"></div>

          {/* Fallback loading state before widget loads */}
          <div className="absolute inset-0 flex items-center justify-center -z-10 bg-slate-900" data-id="element-26">
            <div className="flex flex-col items-center gap-4" data-id="element-27">
              <div className="w-8 h-8 border-4 border-indigo-400 border-t-transparent rounded-full animate-spin" data-id="element-28"></div>
              <p className="text-slate-400 font-medium" data-id="element-29">Loading calendar...</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};